import { Element, InstallSpec, ItemComponent } from "../../../install/types.ts";
import { DatabaseHosting } from "../db/components.ts";

export const MysqlComponents = InstallSpec({
  "iam-write": ItemComponent({
    label: "Access management",
    description: "Manage access to a MySQL instance or cluster.",
    type: "string",
    maturity: "preview",
    schema: {
      hostname: Element({
        label: "Host name",
        description: "The IP address of the instance or cluster",
        type: "generated",
      }),
      port: Element({
        label: "Port",
        description: "The instance or cluster port (defaults to 3306)",
        type: "string",
      }),
      defaultDb: Element({
        label: "Default database",
        description: "Access requests will default to this database (optional)",
        type: "string",
      }),
      hosting: DatabaseHosting,
    },
  }),
});
